import cssHasPseudo from 'css-has-pseudo/browser';
cssHasPseudo(document);

import './components/*';
